export default __webpack_public_path__ + "static/media/RightArrow.38d4038a.svg";